import { render, staticRenderFns } from "./WhatsappsAndEmails.vue?vue&type=template&id=ed8a52e4&scoped=true"
import script from "./WhatsappsAndEmails.vue?vue&type=script&lang=js"
export * from "./WhatsappsAndEmails.vue?vue&type=script&lang=js"
import style0 from "./WhatsappsAndEmails.vue?vue&type=style&index=0&id=ed8a52e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8a52e4",
  null
  
)

export default component.exports